/**
 * Timezones IANA usadas no Brasil + algumas referências regionais.
 * Lista curada — não usa `Intl.supportedValuesOf('timeZone')` (retorna ~400
 * entradas, ruim pra UX num select).
 */
export interface OpcaoTimezone {
  valor: string;
  rotulo: string;
  utc: string;
}

export const TIMEZONES_BRASIL: OpcaoTimezone[] = [
  { valor: 'America/Sao_Paulo', rotulo: 'Brasília / São Paulo', utc: 'UTC−3' },
  { valor: 'America/Bahia', rotulo: 'Bahia', utc: 'UTC−3' },
  { valor: 'America/Belem', rotulo: 'Belém', utc: 'UTC−3' },
  { valor: 'America/Fortaleza', rotulo: 'Fortaleza', utc: 'UTC−3' },
  { valor: 'America/Recife', rotulo: 'Recife', utc: 'UTC−3' },
  { valor: 'America/Maceio', rotulo: 'Maceió', utc: 'UTC−3' },
  { valor: 'America/Araguaina', rotulo: 'Araguaína', utc: 'UTC−3' },
  { valor: 'America/Santarem', rotulo: 'Santarém', utc: 'UTC−3' },
  { valor: 'America/Manaus', rotulo: 'Manaus', utc: 'UTC−4' },
  { valor: 'America/Cuiaba', rotulo: 'Cuiabá', utc: 'UTC−4' },
  { valor: 'America/Campo_Grande', rotulo: 'Campo Grande', utc: 'UTC−4' },
  { valor: 'America/Porto_Velho', rotulo: 'Porto Velho', utc: 'UTC−4' },
  { valor: 'America/Boa_Vista', rotulo: 'Boa Vista', utc: 'UTC−4' },
  { valor: 'America/Rio_Branco', rotulo: 'Rio Branco', utc: 'UTC−5' },
  { valor: 'America/Eirunepe', rotulo: 'Eirunepé', utc: 'UTC−5' },
  { valor: 'America/Noronha', rotulo: 'Fernando de Noronha', utc: 'UTC−2' },
];

export const TIMEZONE_PADRAO = 'America/Sao_Paulo';
